import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'aw-color-swatch',
    templateUrl: './color-swatch.component.html',
    styleUrls: ['./color-swatch.component.less'],
    imports: [MatIconButton, MatIcon, NgStyle]
})
export class ColorSwatchComponent implements OnInit, OnChanges {
  @Input() availableColours: string[] = [];
  @Output() selectedColour: EventEmitter<string> = new EventEmitter<string>();
  chosenColour: string;

  constructor() { }

  ngOnInit() {
  }
  
  colourPicked(colour){
    this.chosenColour = colour;
    this.selectedColour.emit(this.chosenColour);
  }
  
  cancelClicked() {
    this.chosenColour = null;
    this.selectedColour.emit(this.chosenColour);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let availableColours = changes.availableColours.currentValue as string[];
    let foundColour = availableColours.find(e => e === this.chosenColour);
    if(!foundColour) {
      this.chosenColour = null;  
      this.selectedColour.emit(this.chosenColour);
    }
  }

}
